import {AfterViewInit, Component, DestroyRef, inject, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable,
  MatTableDataSource
} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort, MatSortHeader} from '@angular/material/sort';
import {Router} from '@angular/router';
import { CurrentCrudSelectBehaviorServiceAsString
} from '../objectPassingService';
import {AdService} from './ads_service';
import {GetAllAdPayloadModel} from './ad_interfaces';
import {MatProgressBar} from '@angular/material/progress-bar';

import {MatCard} from '@angular/material/card';
import {MatDivider} from '@angular/material/divider';
import {MatFabButton, MatIconButton} from '@angular/material/button';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {MatList, MatListItem} from '@angular/material/list';
import {MatTooltip} from '@angular/material/tooltip';
import {MatTableModule} from '@angular/material/table';

export interface CreateAdInitPayload {
  is_edit: false;
}

@Component({
  selector: 'app-ads',
  imports: [
    MatTableModule,
    MatProgressBar,
    MatCard,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatDivider,
    MatFabButton,
    MatFormField,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatIcon,
    MatIconButton,
    MatInput,
    MatLabel,
    MatList,
    MatListItem,
    MatPaginator,
    MatRow,
    MatRowDef,
    MatSort,
    MatSortHeader,
    MatTable,
    MatTooltip,
    MatHeaderCellDef
],
  templateUrl: './ads.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./ads.component.css']
})
export class AdsComponent implements OnInit, OnDestroy, AfterViewInit  {

  private destroyRef = inject(DestroyRef);
  destroyed = new Subject<void>();
  client_id: number = 0
  client_slug: string = '';
  campaign_group_sequence_id: string = '';
  campaign_group_id: string = '';
  campaign_id: string = '';
  adgroup_id: string = '';
  is_loading = true;

  dataSource!: MatTableDataSource<GetAllAdPayloadModel>;
  displayedColumns: string[] = ['ad_id', 'name', 'status', 'Edit', 'Delete'];
  // @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  // It must not be inside an ngIf without static: true in the @ViewChild
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  constructor(
    public router: Router,
    private currentCrudSelectBehaviorServiceAsString: CurrentCrudSelectBehaviorServiceAsString,
    private adService: AdService
  ) { }

  ngOnInit(): void {

    this.client_id = parseInt(localStorage.getItem('client_id') || '0');
    this.client_slug = localStorage.getItem('client_slug') || '';
    this.campaign_group_id = localStorage.getItem('campaign_group_id') || '';
    this.campaign_id = localStorage.getItem('campaign_id') || '';
    this.adgroup_id = localStorage.getItem('adgroup_id') || '';

    // console.log('####################################################')
    // console.log('client_id', this.client_id)
    // console.log('client_slug', this.client_slug)
    // console.log('campaign_group_id', this.campaign_group_id)
    // console.log('campaign_id', this.campaign_id)
    // console.log('adgroup_id', this.adgroup_id)

    if (this.adgroup_id) {
      this.getData(false)
    } else {
      this.is_loading = false;
    }
  } // end of ngOnInit

  ngAfterViewInit(): void {
    //this.dataSource.paginator = this.paginator;
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  } // end of ngOnDestroy

  getCampaignContextFromStorage(): void {
    this.client_id = parseInt(localStorage.getItem('client_id') || '0');
    this.client_slug = localStorage.getItem('client_slug') || '';
    this.campaign_group_id = localStorage.getItem('campaign_group_id') || '';
    this.campaign_id = localStorage.getItem('campaign_id') || '';
    this.adgroup_id = localStorage.getItem('adgroup_id') || '';
  }

  getData(is_mocked:boolean = false) {

    this.is_loading = true;
    const show_deleted = 'false'
    console.log('SASDASDASDSDSD',this.adgroup_id, is_mocked)

    this.adService.gets(`adserver/ads/${this.adgroup_id}`, is_mocked).pipe(takeUntil(this.destroyed)).subscribe( (data: any) => {
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.is_loading = false;
      }, (error) => {
        console.log('error', error);
        this.is_loading = false;
      }, () => {
        console.log('complete');
        this.is_loading = false;
      }
    ) //end subscribe
  } //end getData

  addAd(is_edit: boolean, row?: GetAllAdPayloadModel): void {
    localStorage.removeItem('adsaved');
    if (is_edit && row) {
      //this.currentCrudSelectServiceReplayEdit.announce(row);
      this.currentCrudSelectBehaviorServiceAsString.announce(JSON.stringify(row));
    } else {
      //this.currentCrudSelectServiceReplayCreate.announce({ is_edit: false });
      const payload: CreateAdInitPayload = { is_edit: false };
      this.currentCrudSelectBehaviorServiceAsString.announce(JSON.stringify(payload));
    }
    // Ensure subscribers are ready before navigation
    // It’s faster and cleaner than setTimeout(..., 0).
    queueMicrotask(() => {
      this.router.navigate(
        ['/nav-campaigns', { outlets: { admeta: ['ads-meta'] } }]
      ).then(() => console.log('Redirected to ads-meta'));
    });
  }

  getTableRecord(row: object) {
  } // end getTableRecord

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  } //end applyFilter

  deleteRow(row: GetAllAdPayloadModel){
    console.log('deleteRow', row);
    let endpoint = `adserver/ad/${row.ad_id}`;
    this.adService.delete(endpoint)
      .pipe(takeUntil(this.destroyed))
      .subscribe((response: any) => {
        console.log('deleteRow response', response);
        this.getData();
      }, (error) => {
        console.error('Error deleting row:', error);
      }, () => {
        console.log('Delete operation completed');
      });
  } //end deleteRow




} // end of AdsComponent
